// test227
(227 && 0);
